/* eslint no-shadow: off */

import keyBy from 'lodash/keyBy';
import * as mutationTypes from '@/store/mutation-types';
import api from '@/api';

const state = {
  departments: [],
  offices: [],
  USStates: [],
  earlyBirdEnrollmentTypes: [],
  referralStates: [],
};

const getters = {
  allDepartments: state => state.departments,
  departmentMap: (state, getters) => keyBy(getters.allDepartments, 'id'),
  allOffices: state => state.offices,
  officeMap: (state, getters) => keyBy(getters.allOffices, 'id'),
  allUSStates: state => state.USStates,
  allEarlyBirdEnrollmentTypes: state => state.earlyBirdEnrollmentTypes,
  allReferralStates: state => state.referralStates,
};

const actions = {
  getDepartments({ commit }) {
    return api.lookup.departments().then(response => commit(mutationTypes.LOOKUP_DEPARTMENTS, response.data));
  },

  getOffices({ commit }) {
    return api.lookup.offices().then(response => commit(mutationTypes.LOOKUP_OFFICES, response.data));
  },

  getUSStates({ commit }) {
    return api.lookup.USStates().then(response => commit(mutationTypes.LOOKUP_US_STATES, response.data));
  },

  getEarlyBirdEnrollmentTypes({ commit }) {
    return api.lookup.earlyBirdEnrollmentTypes().then(response => commit(mutationTypes.LOOKUP_EB_ENROLLMENT_TYPES, response.data));
  },

  getReferralStates({ commit }) {
    return api.lookup.referralStates().then(response => commit(mutationTypes.LOOKUP_REFERRAL_STATES, response.data));
  },
};

const mutations = {
  [mutationTypes.LOOKUP_DEPARTMENTS](state, result) {
    state.departments = result || [];
  },

  [mutationTypes.LOOKUP_OFFICES](state, result) {
    state.offices = result || [];
  },

  [mutationTypes.LOOKUP_US_STATES](state, result) {
    state.USStates = result || [];
  },

  [mutationTypes.LOOKUP_EB_ENROLLMENT_TYPES](state, result) {
    state.earlyBirdEnrollmentTypes = result || [];
  },

  [mutationTypes.LOOKUP_REFERRAL_STATES](state, result) {
    state.referralStates = result || [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
